export function stringToTitleCase(val) {
  return val
    .toLowerCase()
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ")
    .trim();
}
